/**
 * スクロールダウンヒント
 * ページ下部にスクロールを促すアイコンを表示
 * ページ下部まで見えたら自動的に非表示
 */
export default class ScrollDownHint {
  #element;
  #enabled = true;
  #observer;

  /**
   * @param {string} elementId - ヒント要素のID
   */
  constructor(elementId = 'scroll_down_hint') {
    this.#element = document.getElementById(elementId);
    if (this.#element) {
      this.#init();
    }
  }

  #init() {
    this.#checkVisibility();
    window.addEventListener('scroll', () => this.#checkVisibility());
    window.addEventListener('resize', () => this.#checkVisibility());

    // SPAページ遷移を検知するためのMutationObserver
    this.#observer = new MutationObserver(() => {
      // DOM変更後に少し待ってから判定（レンダリング完了を待つ）
      setTimeout(() => this.#checkVisibility(), 100);
    });

    // メインコンテンツエリアを監視
    const contentContainer = document.getElementById('kt_app_content_container');
    if (contentContainer) {
      this.#observer.observe(contentContainer, {
        childList: true,
        subtree: true
      });
    }
  }

  #checkVisibility() {
    if (!this.#enabled) {
      this.#element.classList.add('hidden');
      return;
    }

    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // スクロール可能かチェック（コンテンツが画面より長いか）
    const isScrollable = documentHeight > windowHeight + 50;

    // ページ下部まで見えているかチェック
    const isAtBottom = scrollTop + windowHeight >= documentHeight - 10;

    // スクロール可能で、かつ下部まで見えていない場合のみ表示
    if (isScrollable && !isAtBottom) {
      this.#element.classList.remove('hidden');
    } else {
      this.#element.classList.add('hidden');
    }
  }

  /**
   * ヒントを有効化
   */
  enable() {
    this.#enabled = true;
    this.#checkVisibility();
  }

  /**
   * ヒントを無効化（非表示）
   */
  disable() {
    this.#enabled = false;
    this.#element?.classList.add('hidden');
  }
}
